<n-card-panel class="scan-policy">
    <div slot="title" class="scan-policy-switch">
        <h2>{{scanPolicyTitle}}</h2>
        <n-switch [id]="'scan-policy-switch-' + type"
            [(ngModel)]="switch"
            (onChange)="onSwitchChange($event)">
        </n-switch>
    </div>

    <div class="sub card-tips">{{cardTips}}</div>

    <form [class.hidden]="!switch"
        [formGroup]="vm"
        [errorMessage]="errorMessage"
        class="common-form">
        <!-- 扫描策略 -->
        <n-form-item [label]="i18n.policyLab"
            required="true">
            <div class="interval-10 custom-width">
                <!-- 扫描策略 -->
                <n-select #scanPolicySelect
                    [id]="'create-fs-scan-policy-select-' + type"
                    [rest]="scanPolicyRest"
                    labelField="name"
                    valueField="ID"
                    [restChangeVerify]="false"
                    [filter]="!!scanPolicyRest"
                    (onChange)="scanPolicySelectChange($event)"
                    [formControlName]="'selectedScanPolicy' + type">
                </n-select>
                <!-- 创建 -->
                <button pButton
                    [id]="'create-fs-scan-policy-create-' + type"
                    [label]="i18n.createBtn"
                    [permission]="['antivirus_W']"
                    (click)="createPolicy()">
                </button>
            </div>
            <!-- 所选策略的扫描计划信息 -->
            <ng-container *ngIf="selectPolicyOpt">
                <form *ngIf="type === ScanPolicyTypeE.ONACCESS" id="onaccess-form"
                    class="subText">
                    <!-- 不扫描时间段 -->
                    <n-form-item [label]="i18n.excludePeriod">
                        <span>{{str.excludeFileTypeRender | fn: selectPolicyOpt.data.excludePeriod}}</span>
                    </n-form-item>
                    <!-- 不扫描文件类型 -->
                    <n-form-item [label]="i18n.unscannedFileType">
                        <span *ngIf="selectPolicyOpt.data.excludeFileType === UNPLACEHOLDER">{{UNPLACEHOLDER}}</span>
                        <a *ngIf="selectPolicyOpt.data.excludeFileType !== UNPLACEHOLDER"
                            class="color-click-a" (click)="openDetailWindow(type, ExcludeFileE.TYPE)">
                            {{str.convertToCount | fn: selectPolicyOpt.data.excludeFileType}}
                        </a>
                    </n-form-item>
                    <!-- 不扫描文件路径 -->
                    <n-form-item [label]="i18n.excludeFilePath">
                        <span *ngIf="selectPolicyOpt.data.excludeFilePath === UNPLACEHOLDER">{{UNPLACEHOLDER}}</span>
                        <a *ngIf="selectPolicyOpt.data.excludeFilePath !== UNPLACEHOLDER"
                            class="color-click-a" (click)="openDetailWindow(type, ExcludeFileE.PATH)">
                            {{str.convertToCount | fn: selectPolicyOpt.data.excludeFilePath}}
                        </a>
                    </n-form-item>
                    <!-- 最大可扫描文件大小 -->
                    <n-form-item [label]="i18n.maxScanFileSize">
                        <span>{{str.maxFileSizeRender | fn: selectPolicyOpt.data.maxFileSize}}</span>
                    </n-form-item>
                    <!-- 超时时间 -->
                    <n-form-item [label]="i18n.timeout">
                        <span>{{selectPolicyOpt.data.timeout}}</span>
                    </n-form-item>
                    <!-- 超时后是否可访问 -->
                    <n-form-item [label]="i18n.accessAfterTimeout">
                        <span>{{str.accessAfterTimeoutRender | fn: selectPolicyOpt.data.accessAfterTimeout}}</span>
                    </n-form-item>
                    <!-- 触发时机 -->
                    <n-form-item [label]="i18n.scanTrigger">
                        <span>{{getLabelFromOptions | fn: str.scanTriggerList: selectPolicyOpt.data.scanTrigger}}</span>
                    </n-form-item>
                </form>
                <form *ngIf="type === ScanPolicyTypeE.ONDEMAND" id="ondemand-form"
                    class="subText">
                    <!-- 扫描计划 -->
                    <n-form-item [label]="i18n.scanPlan">
                        <span>{{str.scanPlanRender | fn: selectPolicyOpt.data}}</span>
                    </n-form-item>
                    <!-- 不扫描文件类型 -->
                    <n-form-item [label]="i18n.unscannedFileType">
                        <span *ngIf="selectPolicyOpt.data.excludeFileType === UNPLACEHOLDER">{{UNPLACEHOLDER}}</span>
                        <a *ngIf="selectPolicyOpt.data.excludeFileType !== UNPLACEHOLDER"
                            class="color-click-a" (click)="openDetailWindow(type, ExcludeFileE.TYPE)">
                            {{str.convertToCount | fn: selectPolicyOpt.data.excludeFileType}}
                        </a>
                    </n-form-item>
                    <!-- 不扫描文件路径 -->
                    <n-form-item [label]="i18n.excludeFilePath">
                        <span *ngIf="selectPolicyOpt.data.excludeFilePath === UNPLACEHOLDER">{{UNPLACEHOLDER}}</span>
                        <a *ngIf="selectPolicyOpt.data.excludeFilePath !== UNPLACEHOLDER"
                            class="color-click-a" (click)="openDetailWindow(type, ExcludeFileE.PATH)">
                            {{str.convertToCount | fn: selectPolicyOpt.data.excludeFilePath}}
                        </a>
                    </n-form-item>
                    <!-- 最大可扫描文件大小 -->
                    <n-form-item [label]="i18n.maxScanFileSize">
                        <span>{{str.maxFileSizeRender | fn: selectPolicyOpt.data.maxFileSize}}</span>
                    </n-form-item>
                </form>
            </ng-container>
        </n-form-item>
        <!-- 按需扫描可以配置立即扫描 -->
        <ng-container *ngIf="type === ScanPolicyTypeE.ONDEMAND && entry === ScanMissionEntryTypeE.CREATE">
            <!-- 立即扫描checkbox -->
            <n-form-item [labelHide]="true">
                <n-checkbox id="ondemand-immediately-mission-checkbox"
                    class="mt-10"
                    [label]="i18n.immediately"
                    formControlName="immediately">
                </n-checkbox>
                <div class="sub ml-25">{{i18n.startImmediatelyTip}}</div>
            </n-form-item>
            <!-- 立即扫描持续时间 -->
            <n-form-item *ngIf="vm.value.immediately"
                [helpContent]="vm.value.durationType === DurationTypeE.CUSTOM && i18n.onDemandScanDurationRangeTip"
                [label]="i18n.duration"
                [required]="true">
                <n-radio-group id="create-on-demand-policy-duration-type-radio-group"
                    formControlName="durationType">
                    <!-- 自定义时间 -->
                    <n-radio [value]="DurationTypeE.CUSTOM" id="duration-type-radio-custom"
                        class="custom-radio">
                        <span style="margin-right: .1rem;">{{i18n.custom}}</span>
                    </n-radio>
                    <!-- 直到扫描完成 -->
                    <n-radio [value]="DurationTypeE.UNTILFINISHED" id="duration-type-radio-until-finish">
                        <span>{{i18n.untilFinished}}</span>
                    </n-radio>
                </n-radio-group>
                <!-- 自定义时间可以配置小时和分钟数 -->
                <div *ngIf="vm.value.durationType === DurationTypeE.CUSTOM"
                    class="duration-time-control mt-10">
                    <n-spinner id="create-on-demand-policy-duration-hour-period"
                        style="width: .95rem"
                        [onlyInput]="true"
                        [min]="0"
                        [max]="168"
                        formControlName="durationHour">
                    </n-spinner>
                    <span>{{i18n.hour}}</span>
                    <n-spinner id="create-on-demand-policy-duration-minute-period"
                        style="width: .95rem"
                        [onlyInput]="true"
                        [min]="0"
                        [max]="59"
                        formControlName="durationMinute">
                    </n-spinner>
                    <span>{{i18n.minute}}</span>
                </div>
            </n-form-item>
        </ng-container>
    </form>
</n-card-panel>
